import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import { SubscriptionSimulatorSliceState } from './subscription-simulator.state';
import {
	fetchColumnModelsForSimulationSuccess,
	fetchCurrentSubscriptionSimulationConfigSuccess,
	fetchFilterModelsForSimulationSuccess,
	fetchProfilesForSimulationSuccess,
	fetchProfilesModelsForSimulationSuccess,
	fetchSubscriptionSimulationDataFail,
	fetchSubscriptionSimulationDataSuccess,
	getSubscriptionSimulationData,
	navigateToSubscriptionSimulationWithSelectedColumnModel,
	navigateToSubscriptionSimulationWithSelectedProfile,
	resetSimulationData,
	resetSubscriptionSimulation,
} from './subscription.actions';

export const subscriptionSimulatorReducer =
	createReducer<SubscriptionSimulatorSliceState>(
		new SubscriptionSimulatorSliceState(),
		on(navigateToSubscriptionSimulationWithSelectedProfile, (state, action) =>
			state.setPreSelectedProfile(action.profile)
		),
		on(
			navigateToSubscriptionSimulationWithSelectedColumnModel,
			(state, action) => state.setPreSelectedColumnModel(action.columnModel)
		),
		on(fetchCurrentSubscriptionSimulationConfigSuccess, (state, action) =>
			state.setSimulationSubscription(
				action.subscriptionId,
				action.subscriptionStatus,
				action.metadata
			)
		),
		on(fetchProfilesModelsForSimulationSuccess, (state, action) =>
			state
				.setProfilesForSimulation(action.profiles)
				.setColumnModelsForSimulation(action.columnModels)
				.setFilterModelsForSimulation(action.filterModels)
				.setSubscriptionColumns(action.subscriptionColumns)
		),
		on(fetchProfilesForSimulationSuccess, (state, action) =>
			state.setProfilesForSimulation(action.profiles)
		),
		on(fetchColumnModelsForSimulationSuccess, (state, action) =>
			state.setColumnModelsForSimulation(action.columnModels)
		),
		on(fetchFilterModelsForSimulationSuccess, (state, action) =>
			state.setFilterModelsForSimulation(action.filterModels)
		),
		on(getSubscriptionSimulationData, (state) =>
			state.setLoading(true).setSimulationData(null)
		),
		on(fetchSubscriptionSimulationDataSuccess, (state, action) =>
			state.setSimulationData(action.simulationData).setLoading(false)
		),
		on(fetchSubscriptionSimulationDataFail, (state) => state.setLoading(false)),
		on(resetSimulationData, (state) => state.setSimulationData(null)),
		on(resetSubscriptionSimulation, (state) => state.clear()),
		on(goToProjects, setProject, (state) => state.clear())
	);
